var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.77d21cf8718091aa102ff82bd424dd62.svg#bP';
                    var viewUrl = 'sprites.77d21cf8718091aa102ff82bd424dd62.svg#view-bP';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 32 29',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };